import { CommonService } from '@/app/shared/services/common.service';
import { FileService } from '@/app/shared/services/file.service';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-business-registration-certificate-2',
  templateUrl: './business-registration-certificate-2.component.html',
  styleUrl: './business-registration-certificate-2.component.scss'
})
export class BusinessRegistrationCertificate2Component {

  @ViewChild('loadingModal', { static: false }) loadingModal: TemplateRef<string>;
  @ViewChild('confirmModal', { static: false }) confirmModal: TemplateRef<string>;

  @Input() select2Provinces: any;
  @Input() user: any;
  @Input() files: any[] = [];
  @Input() fileType: any;

  @Output() confirmForm: EventEmitter<any> = new EventEmitter();
  @Output() closeForm: EventEmitter<any> = new EventEmitter();

  form: FormGroup;

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private fileService: FileService,
    private commonService: CommonService,
    private toastService: ToastrService
  ) {
    this.form = this.formBuilder.group({
      businessCertificationsNo: new FormControl('', [Validators.required]),
      businessCertificationsDate: new FormControl('', [Validators.required]),
      businessCertificationsProvince: new FormControl('', [Validators.required]),
    });
  }

  open() {
    this.form.reset();
    let loadingModal = this.modalService.open(this.loadingModal, {
      backdrop: 'static',
      ariaLabelledBy: 'address-add-Modal',
      centered: true,
      size: 'xl',
      windowClass: 'theme-modal modal-login',
    });
    loadingModal.shown.subscribe(() => {
      this.readFiles(this.files);
    });
  }

  openModal() {
    this.modalService.open(this.confirmModal, {
      backdrop: 'static',
      ariaLabelledBy: 'address-add-Modal',
      centered: true,
      size: 'xl',
      windowClass: 'theme-modal modal-login',
    }).result.then(
      (result) => {
        `Result ${result}`;
      },
      (reason) => {}
    );
  }

  readFiles(files: any) {
    this.fileService.uploadTextract(files, this.fileType, this.user.userName).subscribe({
      next: (res: any) => {
        if (res) {
          if (res.ocrResult.confidence_score < 0.9) {
            this.toastService.error('Hình ảnh không rõ nét, vui lòng chọn ảnh khác!', '', { positionClass: 'toast-top-right' });
            // this.onClose();
            return;
          }

          let certificationDate = moment(this.commonService.convertVietnameseDateToNumeric(res.ocrResult.date_of_certificate_issuance)).format('YYYY-MM-DD');

          if (!certificationDate) {
            this.toastService.error('Ngày cấp không hợp lệ!', '', { positionClass: 'toast-top-right' });
          }

          this.form.patchValue({
            businessCertificationsNo: res.ocrResult.id_number,
            businessCertificationsDate: this.commonService.convertDateToNgbDate(certificationDate || ''),
            businessCertificationsProvince: res.ocrResult.issuing_authority,
          });
        }
      },
      error: (err) => {
        console.log(err);
        this.toastService.error('Có lỗi xảy ra, vui lòng thử lại!', '', { positionClass: 'toast-top-right' });
        this.onClose();
      },
      complete: () => {
        this.modalService.dismissAll();
        this.openModal();
      }
    });
  }

  onConfirm() {
    this.confirmForm.emit(this.form.value);
    this.modalService.dismissAll();
  }

  onClose() {
    this.modalService.dismissAll();
    this.closeForm.emit();
  }

}
